export default __webpack_public_path__ + "static/media/groupWhite.20c96985.svg";